module.exports = __webpack_public_path__ + "img/Asset 1.f52488f0.png";